import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { captureInstallPrompt } from "./pwa/install";
import "@fontsource-variable/geist";
import "./styles/base.css";

// O evento de instalação pode chegar antes de o React montar.
captureInstallPrompt();

const root = document.getElementById("root");
if (!root) throw new Error("#root ausente");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
